import { BaseObject } from '../core/BaseObject';
import { UserRole } from './UserRole';
import { UserGroup } from "./user-group";
import { UserServiceCenter } from "./user-service-center";
import { ServiceBoundary } from "./ServiceBoundary"
import { SelfEmployedData } from './selfEmployedData';
import { UserImage } from './userImage';
import { UserMarketPlace } from './user-market-place';
import { UserRequestCategoryDto } from './user-request-category.dto';

export class User extends BaseObject {
	userId: number;
	surname: string;
	name: string;
	middleName: string;
	displayName: string;

	fullAddress: string;

	email: string;
	login: string;
	passwordHash: string;
	isBlocked: boolean;
	blockedReason: string;
	contragentId: number;
	serviceCenterId: number;
	position: string;

	performerUserGroupId: number;
	performerUserGroupName: string;
	isDefaultUserForGroup: boolean;
	integraCode: string;

	contragentName: string;
	serviceCenterName: string;

	blockchainAddress: string;

	warehouseIds: number[] = [];

	lastLoginMoscow: Date;
	createdDateMoscow: Date;

	userRoles: UserRole[] = [];
	userGroups: UserGroup[] = [];
	userServiceCenters: UserServiceCenter[] = [];
	serviceBoundaries: ServiceBoundary[] = [];
	hasServiceBoundariesFilter: boolean;
	userMarketPlaces: UserMarketPlace[] = [];
	userMarketPlaceAvailable: boolean;
	userRequestCategories: UserRequestCategoryDto[] = [];
	requestCategoriesAvailable: boolean;

	selfEmployedData: SelfEmployedData;
	userImage: UserImage;
	mkStatus: string;
	isEngineer: boolean;
	isSelfEmployed: boolean;

	telegramUserName: string;
	hasOtpToken: boolean;

	userMovementTypeId: number;

	/** Яндекс Маршрутизация: старт со склада/офиса. */
	visitDepotAtStart = false;
	/** Id адреса старта (склад/офис) в справочнике. */
	startingDepotAddressId?: number | null;

	/** Финиш на складе/офисе. */
	returnToDepot = false;
	/** Id адреса финиша (склад/офис) в справочнике. */
	endingDepotAddressId?: number | null;
}
